import { Injectable, InjectionToken } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CeRequestOptions } from "../request-header/request-header.component";

export const CE_REQUEST_OPTIONS = new InjectionToken('come and get your route resolved request options!');

@Injectable()
export class ResolvedRequestOptionsService implements ResolvedOptions {
    public requestOptions: CeRequestOptions;

    constructor(private activatedRoute: ActivatedRoute) {
        this.activatedRoute
            .data
            .subscribe(d => {
                this.requestOptions = d.requestOptions;
            });
    }
}

export interface ResolvedOptions {
    requestOptions: CeRequestOptions;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/services/resolved-request-options.ts